import { render, staticRenderFns } from "./TimeAttendanceLocationAdd.vue?vue&type=template&id=20b58060"
import script from "./TimeAttendanceLocationAdd.vue?vue&type=script&lang=js"
export * from "./TimeAttendanceLocationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports